import { Component, OnInit, Input } from '@angular/core';
import { VendorBookedItemsService } from '../services/vendor-booked-items.service';
import { Observable } from 'rxjs';
import { AlertsService } from '../services/alerts.service';
import { DataHolderService } from '../services/data-holder.service';


@Component({
  selector: 'app-display-booked-items',
  templateUrl: './display-booked-items.component.html',
  styleUrls: ['./display-booked-items.component.scss']
})
export class DisplayBookedItemsComponent implements OnInit {

  // Project / Sale ID or Vendor / pURCHASE ID
  @Input() type_of_data: string | number;

  @Input() table_column_id: string | number;


  fetchedAllData: Observable<any>;

  addEditFormVisible: boolean = false;

  fetchedValue: Observable<any>;

  count: number = 0;

  Object = Object;

  isCreate: boolean = true;


  constructor(
    private alertsService: AlertsService,
    public dataHolderService: DataHolderService,
    public vendorBookedItemsService: VendorBookedItemsService,

  ) { }


  ngOnInit(): void {
    this.loadAllData();
  }

  loadAllData(): void {

    this.vendorBookedItemsService.fetchBookedItems(this.type_of_data, this.table_column_id).subscribe((response: any) => {
      if (!response.status) {
        this.alertsService.addAlert("danger", response.message);
        return;
      }

      this.fetchedAllData = response['data'];
      this.count = response['data'].length;
      this.addEditFormVisible = false;

    },
      error => {
        this.alertsService.addAlert("danger", "Server Error, Contact Admin");
      });

  }

  fetchValueAndDisplayForm(id): void {

    this.alertsService.addAlert('info', 'Fetching Data..');

    this.vendorBookedItemsService.fetchBookedItemById(id).subscribe((response: any) => {
      this.alertsService.removeAlert();
      if (!response.status) {
        this.alertsService.addAlert("danger", response.message);
        return;
      }
      this.alertsService.addAlert("success", response.message);
      this.fetchedValue = response['data'];
      this.isCreate = false;
      this.addEditFormVisible = true;

    },
      error => {
        this.alertsService.addAlert("danger", "Server Error, Contact Admin");
      });



  }

  refreshOnlyChildData(): void {
    this.loadAllData();
  }

  // Reloads data of the Parents
  // Parent will trigger reload of all children

  reloadData(data: any = null): void {

    var ele = document.getElementById("refreshDataOfTheParent");
    if (ele) {
      ele.click();
    }

  }


}
